/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_4Inputs */

const en_cap_promise_4 = /** @type {(inputs: Cap_Promise_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A named person`)
};

const lv_cap_promise_4 = /** @type {(inputs: Cap_Promise_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildīgais cilvēks`)
};

/**
* | output |
* | --- |
* | "A named person" |
*
* @param {Cap_Promise_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_4 = /** @type {((inputs?: Cap_Promise_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_4(inputs)
	return en_cap_promise_4(inputs)
});